import styled from 'styled-components'

export const Wrapper = styled.div`
  span {
    background-color: #f5f5f5;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    padding: 4.5px 8px;
    color: #363636;
    font-size: 14px;
    display: inline-block;
    svg {
      height: 12px;
      margin-right: 6px;
      margin-bottom: 1px;
    }
    svg + svg {
      margin-right: 0px;
      margin-left: 6px;
    }
  }
  span + span {
    margin-left: 16px;
  }
`
